<template>
    <main-content-wrapper>
        <h1 class="text-md-center">Sprememba gesla</h1>
        <p class="text-md-center">Vpišite vaše novo geslo.</p>

        <v-alert
            :value="invalid_password_message != null"
            type="error"
        >
          {{ invalid_password_message }}
        </v-alert>
      <empty-space/>
        <v-form v-model="valid" @submit.prevent="" autocomplete="off">
            <password-field autocomplete="off" name="test" v-model="password" :rules="newPasswordRules" label="Geslo" v-on:keypress.enter="resetPassword" required />
            <password-field autocomplete="off" name="test_w" v-model="password_again" :rules="[checkNewPasswordAgain]" label="Ponovno vpisano geslo" v-on:keypress.enter="resetPassword" required />
        </v-form>
        <v-btn depressed large block color="primary_action" @click="resetPassword" :loading="loading">NASTAVI GESLO</v-btn>
    </main-content-wrapper>
</template>

<script>
    import MainContentWrapper from "../components/MainContentWrapper";
    import InputField from "../components/InputField";
    import EmptySpace from "../components/EmptySpace";
    import utils from "../store/utils";
    import PasswordField from "../components/PasswordField";
    import validations from "../components/validations";

    export default {
        name: "ForgotPasswordNew",
        data: vm => ({
            valid: false,
            password: null,
            password_again: null,
            newPasswordRules: validations.newPasswordRules,
        }),
        components: {MainContentWrapper, InputField, EmptySpace, PasswordField},
        computed:{
            loading: utils.vuexBuildSetGet(this, 'auth', 'loading'),
            invalid_password_message: utils.vuexBuildSetGet(this, 'auth', 'invalid_password_message'),
        },
        mounted() {
            this.$trackPageVisit('forgot-password-link-sent');
        },
        methods: {
            resetPassword() {
                if (this.valid) {
                    this.$store.dispatch('auth/resetPassword', {password: this.password});
                }
            },
            checkNewPasswordAgain(v) {
                return validations.newPasswordCheckAgain(v, this.password);
            }
        }
    };

</script>

<style scoped>

</style>